import { DatePipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RdsBadgeComponent } from '@rds/angular-components';

import {
  DestinationFrontendEnum,
  NotificationSourceTypeEnum,
  NotificationStatusEnum,
  NotificationsModel,
  NotificationsService,
  RoleType,
} from '@bookly/shared';

@Component({
  selector: 'bsh-notification',
  imports: [NgClass, RdsBadgeComponent, DatePipe],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  @Input() notification: NotificationsModel | null = null;
  @Output() public isRedirectSuccessful = new EventEmitter<boolean>(false);
  readonly #notificationsService = inject(NotificationsService);
  readonly #router = inject(Router);
  readonly #activatedRoute = inject(ActivatedRoute);
  protected readonly NotificationStatusEnum = NotificationStatusEnum;
  protected readonly NotificationSourceTypeEnum = NotificationSourceTypeEnum;

  protected handleNotificationClick() {
    if (this.notification?.status === NotificationStatusEnum.Unread) {
      this.#notificationsService
        .markNotificationAsRead(this.notification.notificationId)
        .subscribe();
      this.notification.status = NotificationStatusEnum.Read;
      this.#notificationsService.decreaseCounter();
    }
    if (
      this.notification?.destinationFrontend === DestinationFrontendEnum.User
    ) {
      this.#router
        .navigate(
          [
            'dashboard',
            'bookings',
            this.notification.attributes.bookingId,
            this.notification.attributes.roomDexId,
          ],
          { queryParams: { setActiveTab: this.notification.sourceService } }
        )
        .then(successful => {
          this.isRedirectSuccessful.emit(successful);
        });
      return;
    }
    const role = this.#activatedRoute.snapshot.data['role'] as
      | RoleType
      | undefined;
    const panel =
      role === RoleType.SERVICE_PROVIDER ? 'service-provider' : 'room-host';
    this.#router
      .navigate(
        [
          panel,
          'booking-request',
          this.notification?.attributes.roomDexId,
          this.notification?.attributes.bookingId,
        ],
        { queryParams: { setActiveTab: this.notification?.sourceService } }
      )
      .then(successful => {
        this.isRedirectSuccessful.emit(successful);
      });
  }
}
